import {useMemo} from 'react';
import type {ManifestationDesignator} from 'types';
import {useQueryParams} from 'navigation/hooks';
import type {InitialManifestationParam} from '../types';
import {getManifestationDesignatorParam} from '../functions';

export const useManifestationDesignatorParam = ():
  | ManifestationDesignator
  | undefined => {
  const manifestationParam = useQueryParams<InitialManifestationParam>();

  const designator = useMemo(
    () => getManifestationDesignatorParam(manifestationParam),
    [manifestationParam],
  );

  return designator;
};
